import "./Channel.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Form, Input, Spin } from "antd";

import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";

const Ingredients = () => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [ingreList, setIngreList] = useState([]);

	const [second, setSecond] = useState(0);
	// const second = (Math.random() * 10).toFixed();
	useEffect(() => {
		setSecond((Math.random() * 10).toFixed());
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, []);

	useEffect(() => {
		getCategory();
		// if (!history.location.pathname.includes("?id") && reduxChannel?.influencer_id) {
		//     history.replace(`?id=${reduxChannel?.influencer_id}`)
		// }
	}, [reduxChannel]);

	/**
	 * 카테고리 성분별 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const getCategory = async () => {
		setIsLoading(true);
		let param = {
			offset: 0,
			categoryType: "ingredient",
			influencerId: reduxChannel?.user_id,
		};
		const res = await partnersApi.togetherCategoryRead(param);
		if (res.code === 200) {
			setIngreList(
				res.result.ingredientList?.map((item) => ({
					...item,
					bg_color:
						reduxChannel?.user_id === 7
							? item.is_hot
								? "#fe2b4b"
								: item.is_best
								? "#ff8000"
								: reduxChannel?.color_2
								? reduxChannel?.color_2
								: null
							: item.is_hot
							? "#FF8000"
							: item.is_best
							? "#005DA9"
							: reduxChannel?.color_2
							? reduxChannel?.color_2
							: null,
				}))
			);
		}
		setIsLoading(false);
	};

	const bgIngredient = ["#117FFA", "#78B8FF", "#0051AB", "#4791E3"];

	const [isMobile, setIsMobile] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setIsMobile(matchQueryList.matches);

			const media = function handleChange(e) {
				setIsMobile(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	return (
		<div className="channel-home">
			<div className={`home-body`} style={{ gap: 0 }}>
				<div className={`max-width-apply`}>
					<h1 className={`main-title`} id={`main-title`}>
						{reduxChannel?.user_id === 9 ? "고민별" : "성분별"}
					</h1>
					<Form
						size={`large`}
						style={{
							marginRight: "auto",
							display: "flex",
							justifyContent: "flex-end",
							width: "60%",
						}}
						className={`channel-header-search channel-body-search`}
					>
						<Input.Search
							className={`home-search-bar`}
							type={`text`}
							placeholder={`${
								isMobile
									? `검색 예시) ${
											reduxChannel?.placeholder
												? reduxChannel?.placeholder
												: "비타민"
									  }`
									: reduxChannel?.user_id === 9
									? `증상 검색하기 (예시: ${
											reduxChannel?.placeholder
												? reduxChannel?.placeholder
												: "비타민"
									  })`
									: `증상, 영양제 검색하기 (예시: ${
											reduxChannel?.placeholder
												? reduxChannel?.placeholder
												: "비타민"
									  })`
							}`}
							allowClear
							// value={searchValue}
							// onChange={(e) => {
							//     setSearchValue(e.target.value);
							// }}

							onSearch={(value) => {
								if (value?.length > 0) {
									history.push(
										`/together/channel/search?query=${value}&id=${reduxChannel?.influencer_id}`
									);
								}
							}}
						/>
					</Form>

					<div className={`channel-flex-wrap`}>
						{isLoading && (
							<Spin
								style={{
									margin: "auto",
									width: "100%",
									paddingTop: "2em",
									position: "absolute",
									left: 0,
									right: 0,
								}}
							/>
						)}
						{ingreList?.map((item, idx) => (
							<button
								className={`content-button`}
								key={`ingredient-each-${idx}`}
								onClick={() =>
									history.push(
										`/together/channel/ingredients/detail/${item?.ingredient_id}?id=${reduxChannel?.influencer_id}`
									)
								}
							>
								{/*<p className={`channel-home-button-header`}*/}
								{/*   style={{*/}
								{/*       background: `${bgIngredient[(second + idx) % 4]} no-repeat right/100% url("${process.env.REACT_APP_HOST}/assets/images/channel/button-bg-${(second + idx) % 4}.png")`*/}
								{/*   }}*/}
								{/*>*/}
								{/*    {item?.ingredient_name}*/}
								{/*</p>*/}
								<div
									className={`channel-home-button-header not-description`}
									style={{
										borderRadius: 5,
										// background: `${reduxChannel?.color_2 ? reduxChannel?.color_2 : bgIngredient[(second + idx) % 4]} no-repeat right/100% url("${process.env.REACT_APP_HOST}/assets/images/channel/button-bg-${(second + idx) % 4}.png")`
										background: `${
											item?.bg_color
												? item?.bg_color
												: bgIngredient[(second + idx) % 4]
										} no-repeat right/100% url("${
											process.env.REACT_APP_HOST
										}/assets/images/channel/button-bg-${
											(second + idx) % 4
										}.png")`,
									}}
								>
									<p>{item?.ingredient_name}</p>
									<img
										src={`/assets/images/channel/arrow.png`}
										alt={`화살표`}
										style={{
											height: "auto",
											width: "1em",
										}}
									/>
								</div>
								{/*<div className={`channel-home-button-footer`}>*/}
								{/*    <p>*/}
								{/*        {item?.tag}*/}
								{/*    </p>*/}
								{/*    <img*/}
								{/*        src={`/assets/images/channel/arrow.png`}*/}
								{/*        alt={`화살표`}*/}
								{/*        style={{*/}
								{/*            height: "auto",*/}
								{/*            width: "1.5em"*/}
								{/*        }}*/}
								{/*    />*/}
								{/*</div>*/}
							</button>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
export default Ingredients;
